import {IController, IModule} from "angular";
import _ from "lodash";
import {Debugger} from "debug";
import {RedigerEksternMøtedeltakerModell} from "./redigerEksternDeltakerSkjemalinje";
import {dersomChangesInneholder} from "../../../../../felles/stoettefunk/angularHjelpemetoder";
import {l} from "../../../../../types/typescriptdefinisjoner_lederplan";

const debug: Debugger = require('debug')('RedigerEksterneDeltakereKontroller');
const css = require('./redigerEksterneDeltakere.scss');


export class RedigerEksterneDeltakereKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmRedigerEksterneDeltakere', {
                bindings: {deltakere: '<'},
                controller: RedigerEksterneDeltakereKontroller.forInjisering(),
                template: require('./redigerEksterneDeltakere.html')
            });
    }

    static forInjisering() {
        return [
            RedigerEksterneDeltakereKontroller
        ];
    }

    deltakere: RedigerEksternMøtedeltakerModell[]; //settes via require

    viserSkjema = false;

    constructor() {
    }

    harEksterneDeltakere(){
        return this.deltakere?.some(e => !_.isEmpty(e.spesifikasjon.navn));
    }

    sikreAtSisteRadErBlanktInnslag(){
        if (this.deltakere.length == 0)
            this.deltakere.push(RedigerEksternMøtedeltakerModell.tomRedigerEksternDeltakerModell());

        const sisteRad = _.last(this.deltakere);
        if (_.isEmpty(sisteRad.spesifikasjon.navn))
            return;

        this.deltakere.push(RedigerEksternMøtedeltakerModell.tomRedigerEksternDeltakerModell());
    }

    $onChanges(endringer: angular.IOnChangesObject): void {
        dersomChangesInneholder(endringer, 'deltakere', deltakere => {
            this.sikreAtSisteRadErBlanktInnslag()
        });
    }

    static spesifikasjoner(deltakere: RedigerEksternMøtedeltakerModell[]): l.EksternMøtedeltakerSpesifikasjon[] {
        return deltakere
            .filter(d => !d.slettet)
            .filter(d => !_.isEmpty(d.spesifikasjon.navn))
            .map(d => d.spesifikasjon);
    }

    // hjelpemetoder

}
